import { render, staticRenderFns } from "./Balkon.vue?vue&type=template&id=43da7dbc&"
import script from "./Balkon.vue?vue&type=script&lang=js&"
export * from "./Balkon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports